export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9188.0cb01ede.jpg";